import React from 'react';
import { motion } from 'framer-motion';
import { Check, FileText, Printer } from 'lucide-react';
export function WhatsInside() {
  return <section className="py-24 px-6 max-w-4xl mx-auto" data-id="element-206">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.5
    }} data-id="element-207">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center mb-16 text-charcoal" data-id="element-208">
          What you’ll get inside the PDF
        </h2>

        <div className="grid md:grid-cols-2 gap-12" data-id="element-209">
          {/* Core Content */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-charcoal/5" data-id="element-210">
            <div className="flex items-center gap-3 mb-6 text-muted-blue" data-id="element-211">
              <FileText className="w-6 h-6" data-id="element-212" />
              <h3 className="text-xl font-bold uppercase tracking-wide" data-id="element-213">
                The Quiet House Reset
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-214">
              {['Day 0 setup (10 minutes)', 'Morning Anchor (Green/Yellow/Red versions)', 'After-school Re-entry Anchor (with decompression menu)', '6‑Minute Reset (timer-based, no debate)', 'Bedtime Shutdown Anchor (3 steps, same words)', 'Default scripts for the moments you snap', 'The 10‑Minute Daily Reset (maintenance)', 'The Bad-Day Protocol (minimum viable calm)'].map((item, i) => <li key={i} className="flex items-start gap-3 text-charcoal/90" data-id="element-215">
                  <Check className="w-5 h-5 text-sage shrink-0 mt-0.5" data-id="element-216" />
                  <span data-id="element-217">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Printables */}
          <div className="bg-[#F2EFE9] p-8 rounded-2xl border border-charcoal/5 h-fit" data-id="element-218">
            <div className="flex items-center gap-3 mb-6 text-terracotta" data-id="element-219">
              <Printer className="w-6 h-6" data-id="element-220" />
              <h3 className="text-xl font-bold uppercase tracking-wide" data-id="element-221">
                Printables Included
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-222">
              {['14‑day checklist', 'Script cards (cut-outs)', 'Anchor trackers'].map((item, i) => <li key={i} className="flex items-start gap-3 text-charcoal/90" data-id="element-223">
                  <Check className="w-5 h-5 text-terracotta shrink-0 mt-0.5" data-id="element-224" />
                  <span data-id="element-225">{item}</span>
                </li>)}
            </ul>

            <div className="mt-8 pt-8 border-t border-charcoal/10" data-id="element-226">
              <p className="text-sm text-charcoal/60 italic" data-id="element-227">
                Instant digital download. Access immediately after purchase.
              </p>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}